const HEADING_SELECTOR = 'h2, h3, h4';

function normalize(value = '') {
  return value.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
}

function cleanClone(node) {
  const clone = node.cloneNode(true);
  if (!(clone instanceof HTMLElement)) return clone;

  clone.querySelectorAll('*').forEach((element) => {
    element.removeAttribute('style');
    element.removeAttribute('class');
    element.removeAttribute('id');
  });
  clone.removeAttribute('style');
  clone.removeAttribute('class');
  clone.removeAttribute('id');
  clone.querySelectorAll('img, video, iframe, script, style').forEach((element) => element.remove());
  clone.querySelectorAll('ul, ol').forEach((list) => {
    [...list.children].slice(6).forEach((item) => item.remove());
  });
  return clone;
}

function sectionNodes(heading) {
  const nodes = [];
  let next = heading.nextElementSibling;

  while (next && !next.matches(HEADING_SELECTOR) && nodes.length < 3) {
    if (next.textContent?.trim()) nodes.push(cleanClone(next));
    next = next.nextElementSibling;
  }
  return nodes;
}

function descriptionAnswers(source) {
  const answers = new Map();
  source.querySelectorAll(HEADING_SELECTOR).forEach((heading) => {
    const title = normalize(heading.textContent || '');
    let key = '';
    if (/what s included|what is included|included in|in the box|package includes/.test(title)) key = 'included';
    else if (/install|mounting/.test(title)) key = 'installation';
    else if (/choose (your|the)|finish|color options|style options|variant/.test(title)) key = 'finish';
    if (!key || answers.has(key)) return;

    const nodes = sectionNodes(heading);
    if (nodes.length) answers.set(key, nodes);
  });
  return answers;
}

function createItem(question, nodes, open = false) {
  const details = document.createElement('details');
  if (open) details.open = true;

  const summary = document.createElement('summary');
  const label = document.createElement('span');
  label.textContent = question;
  const icon = document.createElement('i');
  icon.setAttribute('aria-hidden', 'true');
  icon.textContent = '+';
  summary.append(label, icon);

  const answer = document.createElement('div');
  nodes.forEach((node) => answer.append(node));
  details.append(summary, answer);
  return details;
}

function fitmentAnswer(section) {
  const cards = [...section.querySelectorAll('.kraven-fitment-card')];
  const fragment = document.createDocumentFragment();
  const intro = document.createElement('p');
  intro.textContent =
    'Match your vehicle, model year, trim and any required factory configuration shown in the exact-fitment cards.';
  fragment.append(intro);

  if (cards.length) {
    const list = document.createElement('ul');
    cards.slice(0, 4).forEach((card) => {
      const vehicle = card.querySelector('.kraven-fitment-card__vehicle strong')?.textContent?.trim();
      const year = card.querySelector('.kraven-fitment-card__year strong')?.textContent?.trim();
      const trims = card.querySelector('.kraven-fitment-card__trims p')?.textContent?.trim();
      if (!vehicle || !year) return;
      const item = document.createElement('li');
      item.textContent = `${vehicle} · ${year}${trims ? ` · ${trims}` : ''}`;
      list.append(item);
    });
    if (list.children.length) fragment.append(list);
  }

  const link = document.createElement('a');
  link.href = '#kraven-exact-fitment';
  link.textContent = 'Review exact fitment';
  fragment.append(link);
  return [...fragment.childNodes];
}

function enhanceFaq(section) {
  const list = section.querySelector('[data-kraven-faq-list]');
  const description = section.querySelector('.kraven-technical__guide-content');
  if (!list || !description || list.dataset.enhanced === 'true') return;

  const answers = descriptionAnswers(description);
  const items = [createItem('Will this fit my exact vehicle?', fitmentAnswer(section), true)];

  if (answers.has('included')) {
    items.push(createItem('What is included with this product?', answers.get('included')));
  }
  if (answers.has('installation')) {
    items.push(createItem('What should I know before installation?', answers.get('installation')));
  }
  if (answers.has('finish')) {
    items.push(createItem('How do I choose the right finish or option?', answers.get('finish')));
  }

  if (items.length < 2) return;
  list.replaceChildren(...items);
  list.dataset.enhanced = 'true';
}

document.querySelectorAll('.kraven-technical').forEach(enhanceFaq);
